const interventionFlowsEvents = {
  providerSearchEvents: {
    resultsPage: {
      showMoreClick: 'Click on Show More',
    },
  },
};

export default interventionFlowsEvents;
